import { DateTime } from 'luxon';

export function TimeZoneName(props: { timeZone: string }) {
  const now = DateTime.now();
  const inTz = now.setZone(props.timeZone);

  if (now.offset === inTz.offset) return null;
  return <span>All times in {inTz.offsetNameShort}</span>;
}
